export const FETCH_STANDUP_BY_ID = 'fetchStandupById';
export const FETCH_STANDUPS_BY_IDS = 'fetchStandupsByIds';
export const FETCH_CURRENT_DAY_STANDUP_BY_TEAM = 'fetchCurrentDayStandupByTeam';
export const CREATE_STANDUP = 'createStandup';
export const UPDATE_STANDUP = 'updateStandup';
